// extracted by mini-css-extract-plugin
export var arrow = "_ko-1";
export var content = "_ko-0";
export var highlighted = "_ko-2";